import React, { useContext, useEffect, useState } from 'react';
import { MyContext } from '../../Components/Context';
import CustomerLogsPage from './CustomerLog';
import AdminActivities from './../Parametres/adminActivities';
import AdminLogsPage from './AdminLog';

const MainLog = () => {
  const [selectedTab, setSelectedTab] = useState('Admin');
    const { actifItem, setActifItem } = useContext(MyContext);

  
  return (
    <div className="p-6 transition duration-300 ease-in-out shadow-lg ">
      {/* Tabs de navigation */}
      <div className="flex mb-4 space-x-4">
        <button
          onClick={() => setSelectedTab('Admin')}
          className={`px-4 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-400 transition-all duration-300 ${
            selectedTab === 'Admin' ? 'bg-indigo-600 text-white shadow-lg transform scale-105' : 'bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-gray-300 hover:bg-gray-300 dark:hover:bg-gray-600'
          }`}
        >
          Journal Administrateur
        </button>
        <button
          onClick={() => setSelectedTab('User')}
          className={`px-4 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-400 transition-all duration-300 ${
            selectedTab === 'User' ? 'bg-indigo-600 text-white shadow-lg transform scale-105' : 'bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-gray-300 hover:bg-gray-300 dark:hover:bg-gray-600'
          }`}
        >
          Journal systeme
        </button>
        
      </div>

      {/* Contenu des Tabs */}
      <div className="p-4 transition duration-500 ease-in-out rounded-lg bg-gray-50 dark:bg-gray-800">
        {selectedTab === 'User' && <CustomerLogsPage />}
        {selectedTab === 'Admin' && <AdminLogsPage />}
        
      </div>
    </div>

  );
};

// Composant pour voir les annonces premium

    
    



// Composant pour voir et gérer les propriétaires premium


// Composant pour envoyer un mail


export default MainLog;
